/** Função para acessar o assets/images e retornar uma imagem
 * path -> string = caminho dentro do assets/images
 * imgName -> string = nome da imagem com extenção
 * exemplo de uso getImage('icons', down.png)
 * * isPublic -> bool = imagem dentro de public
 */

const getImage = (path, imgName, isPublic) => {
    let img = null;
    if (imgName) {
        try {
            if(isPublic) img = require(`/public/images${path && `/${path}`}/${imgName}`);
            else img = require(`../assets/images${path && `/${path}`}/${imgName}`);
        } catch (err) {
            img = null;
        }
    }
    return img
}

export default getImage